import Vue                      from "vue";
import { IPartAddRequestDto }   from "@/types";
import LoadingSpinner           from "@/components/Elements/LoadingSpinner.vue";
import { PartSearchService }    from "@/services/";
import { mapGetters }           from "vuex";
import { inputValidateState }   from "@/components/mixins/inputValidateState";
import { DnFormInput }          from "@/components/Elements";

export default Vue.extend({
    name: "SuggestPart",
    mixins: [inputValidateState],
    components: {
        LoadingSpinner,
        DnFormInput
    },
    data: () => ({
        partAddRequest: {} as IPartAddRequestDto,
        isSubmittingRequest: false,
        showSuggestPartForm: true,

        // form fields
        partNumber: "",
        oem: "",
        truckModelNumber: "",
        truckSerialNumber: "",
        name: "",
        email: "",
        phoneNumber: "",
        contactMethod: "",
        comment: "",
    }),
    created() {
        this.name = this.user.FullName;
        this.email = this.user.Email;
        this.phoneNumber = this.user.Phone;
        this.contactMethod = "none";
        this.partNumber = this.searchTerm;
    },
    computed: {
        ...mapGetters(["user","getContentItem"]),
        formIsValid() {
            var haveAllRequiredFields =
                this.name != "" &&
                this.email != "" &&
                this.phoneNumber != "" &&
                this.contactMethod != "" &&
                this.contactMethod != "none" &&
                this.oem != "" &&
                this.truckModelNumber != "" &&
                this.truckSerialNumber != "" &&
                this.partNumber != "";
            return haveAllRequiredFields;
        }
    },
    props: {
        searchTerm: {}
    },
    methods: {
        SendSuggestPart() {
            let successMsgLine1 = "Thank you for your valued input! Your request has been submitted to our Product Development Department<br /><br />";
            let successMsgLine2 = "A Product Development Analyst may soon contact you about your request.";
            this.isSubmittingRequest = true;
            this.partAddRequest.ExternalUserId = this.user.UserId
            this.partAddRequest.Email = this.email
            this.partAddRequest.Name = this.name
            this.partAddRequest.DealerCode = this.user.DealerCode
            this.partAddRequest.Phone = this.phoneNumber
            this.partAddRequest.ContactMethod = this.contactMethod
            this.partAddRequest.PartNumber = this.partNumber
            this.partAddRequest.Oem = this.oem
            this.partAddRequest.TruckModel = this.truckModelNumber
            this.partAddRequest.TruckSerial = this.truckSerialNumber
            this.partAddRequest.Comments = this.comment
            PartSearchService.PartAddRequest(this.partAddRequest).then(response => {
                this.$parent.HideSuggestPart()
            }).finally(() => {
                this.isSubmittingRequest = false;
                this.$store.commit("pushTimedMessage", {
                    header: `Success`,
                    message: `${successMsgLine1}${successMsgLine2}`,
                    IsError: false,
                    seconds: 5
                })
            })
        }
    }
})